'use client';

import * as React from 'react';
import { cn } from '@/lib/utils';

type MHBadgeVariant = 'default' | 'success' | 'warning' | 'error';

type LegacyTone = 'neutral' | 'muted' | 'info' | 'success' | 'warning';

export interface MHBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: MHBadgeVariant;
  tone?: LegacyTone;
}

export function MHBadge({ variant, tone, className, ...props }: MHBadgeProps) {
  const resolvedVariant: MHBadgeVariant = variant
    ? variant
    : tone === 'warning'
      ? 'warning'
      : tone === 'success'
        ? 'success'
        : 'default';

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-[13px] font-medium',
        resolvedVariant === 'default' && 'bg-surface-2 text-text-2',
        resolvedVariant === 'success' && 'bg-surface-2 text-text-1',
        resolvedVariant === 'warning' && 'bg-surface-2 text-text-2',
        resolvedVariant === 'error' && 'bg-surface-2 text-text-1',
        className
      )}
      {...props}
    />
  );
}
